import {
  Component,
  Input,
} from '@angular/core';
import {LookupService} from "../../srvs/lookup";

@Component({
  selector: 'micro-contactEmail-lookup',
  templateUrl: './micro-contactEmail-lookup.component.html'
})
export class MicroContactEmailLookupComponent  {

  @Input()
  contactId:any;

  @Input()
  span:false;
}
